module.exports = __webpack_public_path__ + "img/contra.6d06cb3c.jpeg";